// extracted by mini-css-extract-plugin
export var footer = "ModalAutocomplete-module--footer--6ff82";
export var hideModal = "ModalAutocomplete-module--hide-modal--30bd4";